import { adminContracts, type AdminContract } from './generated/adminContracts'

export function isPrimaryNavigationContract(contract: AdminContract): boolean {
  return !contract.path.includes(':')
}

export function adminNavigationGroups(contracts: readonly AdminContract[] = adminContracts) {
  const grouped = new Map<string, AdminContract[]>()
  for (const contract of contracts) {
    if (!isPrimaryNavigationContract(contract)) continue
    const items = grouped.get(contract.group) ?? []
    items.push(contract)
    grouped.set(contract.group, items)
  }
  return [...grouped.entries()]
}
